import React from 'react';
import Icon from '../../../components/AppIcon';

const PatientHeader = ({ patient }) => {
  const formatLastActivity = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Active now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    return date?.toLocaleDateString();
  };

  const getRiskLevelColor = (level) => {
    switch (level?.toLowerCase()) {
      case 'high': return 'text-red-600 bg-red-50';
      case 'medium': return 'text-yellow-600 bg-yellow-50';
      case 'low': return 'text-green-600 bg-green-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Patient Info */}
        <div className="flex items-center space-x-4">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
            <Icon name="User" size={24} color="#2563eb" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{patient?.name}</h1>
            <div className="flex items-center space-x-4 text-sm text-gray-600 mt-1">
              <span>ID: {patient?.id}</span>
              <span>•</span>
              <span>Age: {patient?.age}</span>
              <span>•</span>
              <span>{patient?.gender}</span>
            </div>
          </div>
        </div>

        {/* Status & Activity */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex items-center space-x-3">
            <div className={`px-3 py-1 rounded-full text-sm font-medium ${getRiskLevelColor(patient?.riskLevel)}`}>
              {patient?.riskLevel} Risk
            </div>
            <div className={`w-3 h-3 rounded-full ${patient?.status === 'active' ? 'bg-green-500' : 'bg-gray-400'}`} />
            <span className="text-sm text-gray-600 capitalize">{patient?.status}</span>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Icon name="Clock" size={16} />
            <span>Last activity: {formatLastActivity(patient?.lastActivity)}</span>
          </div>
        </div>
      </div>
      {/* Quick Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-gray-200">
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">{patient?.totalSymptomLogs}</div>
          <div className="text-sm text-gray-600">Symptom Logs</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600">{patient?.cognitiveScores}</div>
          <div className="text-sm text-gray-600">Game Sessions</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-purple-600">{patient?.avgSeverity}</div>
          <div className="text-sm text-gray-600">Avg Severity</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-orange-600">{patient?.daysSinceLastLog}</div>
          <div className="text-sm text-gray-600">Days Since Last</div>
        </div>
      </div>
    </div>
  );
};

export default PatientHeader;